<template>
  <div class="w-100">
    <label v-if="label" class="mb-0 c-label" :class="labelClass">{{ label }}</label>
    <div class="c-select" :class="disabled ? 'bg-light-grey' : (readonly ? 'white' : '')" @blur="open = false">
      <div ref="select" class="selected" :class="open ? boxClass + ' open': boxClass" @click="disabled || readonly ? '' : toggleOpen()">
        <div v-if="typeof selected === 'object'">
          <span v-if="placeholder && !selected">{{ placeholder }}</span>
          <span v-if="defaultValue && defaultValue !== selected[itemText]">{{ defaultValue }}</span>
          <span v-else>
            <img v-if="selected.type && selected.type == 'View::List'" class="mr-2" src="../../assets/images/icons/c_list_green.svg">
            <img v-if="selected.type && selected.type == 'View::Board'" class="mr-2" src="../../assets/images/icons/c_board_orange.svg">
            <img v-if="selected.type && selected.type == 'View::Calendar'" class="mr-2" src="../../assets/images/icons/c_calendar_purple.svg">
            <v-icon v-if="selected.type && selected.type == 'Analytic::Finance'" class="mr-2 mb-1" dense color="rgba(51, 51, 51, 1)">mdi-database-outline</v-icon>
            <v-icon v-if="selected.type && selected.type == 'Analytic::Case'" class="mr-2 mb-1" dense color="rgba(51, 51, 51, 1)">mdi-dresser-outline</v-icon>
            <v-icon v-if="selected.type && selected.type == 'Analytic::Task'" class="mr-2 mb-1" dense color="rgba(51, 51, 51, 1)">mdi-book-open-outline</v-icon>
            <v-icon v-if="selected.type && selected.type == 'Analytic::Invoice'" class="mr-2 mb-1" dense color="rgba(51, 51, 51, 1)">mdi-receipt</v-icon>
            <v-icon v-if="selected.type && selected.type == 'Analytic::Payment'" class="mr-2 mb-1" dense color="rgba(51, 51, 51, 1)">mdi-currency-usd</v-icon>
            {{ selected[itemText] }}
            <span v-if="itemDescription"> - {{ selected[itemDescription] }}</span>
          </span>
        </div>
        <div v-else>
          <span class="text-grey" v-if="placeholder && !selected">{{ placeholder }}</span>
          <span v-if="defaultValue && defaultValue !== selected">{{ defaultValue }}</span>
          <span v-else>{{ selected.replace(/_/g, ' ') }}</span>
        </div>
      </div>
      <div class="chevron" style="right: 10px;" :class="{ open: open }" @click="toggleOpen()"></div>
      <div class="c-items" style="max-height: 200px" :class="{ selectHide: !open, dropdownUp: isDropdownUp }">
        <div class="pl-0 pr-2" :style="i < options.length - 1 ? 'border-bottom: 1px solid #BDBDBD;' : ''" v-for="(option, i) of options" :key="i" @click="selectOption(option)">
          <CListItem :anotherAddsFunction="anotherAddsFunction" :itemDescription="itemDescription" :addsFunction="addsFunction" :itemText="itemText" :option="option" :itemClass="itemClass" :anotherAddsClass="anotherAddsClass"></CListItem>
        </div>
        <slot name="slot-card"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import CListItem from './c-list-item'
export default {
  components: {
    CListItem
  },
  props: {
    value: {
      type: [String, Number, Object, Boolean]
    },
    options: {
      type: Array
    },
    itemText: {
      type: String
    },
    itemValue: {
      type: String
    },
    label: {
      type: String
    },
    changeFunction: {
      type: Function,
      required: false,
      default: function () {
      }
    },
    addsFunction: {
      type: Function
    },
    anotherAddsFunction: {
      type: Function
    },
    defaultValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    itemDescription: {
      type: String,
      default: ''
    },
    labelClass: {
      type: String,
      default: ''
    },
    boxClass: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    itemClass: {
      type: String,
      default: ''
    },
    anotherAddsClass: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: this.options.length > 0 ? this.options[0] : null,
      open: false,
      isDropdownUp: false,
    };
  },
  watch: {
    value: {
      handler(val) {
        this.resetData(val)
      }
    },
    open: {
      handler(val) {
        this.$emit("isOpen", val)
      }
    },
    isOpen: {
      handler(val) {
        this.open = val
      }
    }
  },
  mounted() {
    this.resetData(this.value)
    if (this.placeholder){
      this.$emit("input", '')
    }else{
      if (this.itemValue) this.$emit("input", this.selected[this.itemValue] ?? this.selected)
      else this.$emit("input", this.selected)
    }
  },
  methods: {
    toggleOpen() {
      this.open = !this.open
      this.calculateDropdownPosition()
    },
    selectOption(option) {
      this.selected = option
      this.open = false
      if(this.itemValue) {
        this.$emit('input', option[this.itemValue])
        this.changeFunction()
      }
      else {
        this.$emit('input', option)
        this.changeFunction()
      }
    },
    resetData (payload) {
      if (this.options.length > 0) {
        if (payload && payload !== '') {
          var found = this.options.find(opt => opt[this.itemValue] === payload)
          if (found) this.selected = found
          else this.selected = payload
        } else {
          if(this.placeholder){
            this.selected = ''
          }else{
            this.selected = this.options[0]
          }
        }
      }
    },
    calculateDropdownPosition() {
      const appRect = document.querySelector('.v-application').getBoundingClientRect()
      const selectRect = this.$el.getBoundingClientRect()
      const selectBottomRelativeToApp = selectRect.bottom - appRect.top
      const appHeight = appRect.height
      this.isDropdownUp = selectBottomRelativeToApp > (appHeight - selectBottomRelativeToApp)
    }
  }
};
</script>

<style scoped>
  .bg-light-grey {
    background: #F2F2F2;
  }
</style>